<template>
    <article class="thank-you-page">
        <FormHeader/>
        <ShowStep :current="3"/>
        <h2>認定登録申し込み完了</h2>
        <section class="section-one">
            <h3>お申し込みありがとうございました。</h3>
        </section>
        <div class="contact-info">
            <ul>
                <li>
                    <h6>お問い合わせ</h6>
                    <p>contact@jaca2021.or.jp</p>
                </li>
            </ul>
            <p>
                受付時間／10:00〜17:00（土曜・日曜・祝日を除く）
            </p>
        </div>
        <section class="section-two">
            <a href="https://jaca2021.or.jp" class="link">
                TOPページへ
            </a>
        </section>
    </article>
</template>

<script>
import SectionLabel from "../../parts/app/SectionLabel";
import FormHeader from "../../parts/kyuseiki/FormHeader";
import ShowStep from "../../parts/kyuseiki/ShowStep";
import { clearFormData } from "../../utils/formDataCookie";

export default {
    name: "ThankYou",
    components: { ShowStep, FormHeader, SectionLabel },
    mounted() {
        // 決済完了後、Cookieに保存されたフォームデータをクリア
        clearFormData();
    }
}
</script>

<style scoped>
h2 {
    @apply text-main-color relative mt-10;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
    letter-spacing: 0.16em;
}

h2:after {
    @apply absolute;
    width: 40px;
    height: 2px;
    content: "";
    background-color: #d11a30;
    margin-right: auto;
    margin-left: auto;
    bottom: -20px;
    left: 0;
    right: 0;
}

h3 {
    @apply text-main-color;
    font-size: 18px;
    line-height: 63px;
    letter-spacing: 0.12em;
}

.section-one {
    @apply mt-4 lg:text-center p-2;
}

.section-two {
    @apply p-2 lg:text-center mt-8 w-[20%] mx-auto;
    height: 55px;
    @media screen and (max-width:1024px) {
        width: 50%;
    }
}

.information {
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0.1em;
}

.notice {
    @apply mt-4;
    color: #e5495c;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.1em;
}

.contact-info {
    @apply max-w-full mx-auto mt-8 p-8;
    width: 800px;
    background-color: #f2f8fb;
}

.contact-info ul {
    @apply flex flex-col lg:flex-row justify-center;
}

.contact-info ul li {
    @apply lg:text-center flex-1 relative;
}

.contact-info ul li:not(:first-of-type) {
    @apply mt-4 lg:mt-0;
}

.contact-info ul li:not(:last-of-type):after {
    @apply absolute h-full top-0 bottom-0 right-0 hidden lg:block;
    content: "";
    background-color: #dfe8ec;
    width: 1px;
}

.contact-info ul li h6 {
    font-size: 16px;
    letter-spacing: 0.12em;
}

.contact-info ul li p {
    @apply mt-2;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.12em;
    color: #006098;
}

.contact-info > p {
    @apply mt-8 lg:text-center;
    font-size: 14px;
    letter-spacing: 0.1em;
}
</style>
